import {
  Module,
  VuexModule,
  Mutation,
  Action,
  MutationAction,
} from "vuex-module-decorators";

/**
 * 🧩 Module which holds the general user information
 */
@Module
export default class ExchangesModule extends VuexModule {
  // 📦 The current user's name
  public username?: string;

  // 📦 The current user's email
  public email?: string;

  // 🚩 Flag for whether the user's email is verified
  public isUserEmailVerified: boolean = true;

  // 📦 The time at which the user's account was created
  public createdOn: number = 0;

  /**
   * 👾 Updates the current user's username
   * @param username
   */
  @Mutation
  public SET_USER_NAME(username?: string) {
    this.username = username;
  }

  /**
   * 👾 Updates the current user's email
   * @param email
   */
  @Mutation
  public SET_USER_EMAIL(email?: string) {
    this.email = email;
  }

  /**
   * 👾 Mutation for changing whether the user's email is verified
   * @param isUserEmailVerified
   */
  @Mutation
  public SET_USER_EMAIL_VERIFIED_FLAG(isUserEmailVerified: boolean) {
    this.isUserEmailVerified = isUserEmailVerified;
  }

  /**
   * 🔨 Action that changes the flag for whether the user email is verified
   * @param showCoinAmount
   */
  @Action
  public changeUserEmailVerifiedFlag(isUserEmailVerified: boolean) {
    this.context.commit("SET_USER_EMAIL_VERIFIED_FLAG", isUserEmailVerified);
  }

  /**
   * 👾 Mutation for changing the user's creation time
   * @param isUserEmailVerified
   */
  @Mutation
  public SET_USER_CREATION_TIME(createdOn: number) {
    this.createdOn = createdOn;
  }

  /**
   * 🔨 Action that sets the time at which the user has joined the platform
   * @param createdOn
   */
  @Action
  public async changeUserCreationTime(createdOn: number) {
    this.context.commit("SET_USER_CREATION_TIME", createdOn);
  }
}
